<template>
  <div class="home">
    MERCADO PENDING
  </div>
</template>

<script>
//import { useToast } from "vue-toastification";
//const toast = useToast();

export default {
  name: 'ViewMercadoPending',
  mounted() {
    
  },
  data() {
    return {
      
    };
  },  
  methods: {
    
  },
  
};
</script>

<style scoped>

</style>
